import { RumInit } from '@maersk-global/telemetry-web-sdk';

const mopInstance = RumInit({
  app: {
    name: import.meta.env.APP_MOP_CLIENT_NAME,
    version: import.meta.env.APP_MOP_CLIENT_VERSION,
    environment: import.meta.env.MODE,
  },
  apiKey: import.meta.env.APP_MOP_SECRET_KEY,
  debug: false, // false: Prevent showing log,error,etc captured in browser console
  traceLog: false, // Sends trace information to Loki ( For easy querying of traces)
  performanceInstrument: { ignoreEvents: ['msal.*'] },
  useSendBeacon: false, // false: Prevent RUM API calls getting blocked by adblockers
});

export default mopInstance;
